import { Typography } from "@mui/material";
import React, { useState } from "react";
import DashboardTable from "../../../components/Dashboard/DashboardTable";
import Template from "../../../components/Dashboard/Template";
import ServiceModal from "../../../components/serviceModal";
import appcolors from "../../../constants/Colors";

const displayRows = [
  "appointmentId",
  "dateMonth",
  "assingedBranch",
  "user_detaile",
  "appoindment_details",
];

const headerData = [
  {
    id: 1,
    label: "Appointment#Id",
  },
  {
    id: 2,
    label: "Day-Month",
  },
  {
    id: 3,
    label: "Branch-Name",
  },
  {
    id: 3,
    label: "User-Detail",
  },
  {
    id: 4,
    label: "Appointment-Details",
  },
];

function AppointmentActivity({ data }) {
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleViewDetails = (row) => {
    setSelectedRow(row);
    setOpen(true);
  };
  return (
    <Template
      primaryHeading={"Upcoming Appointment"}
      secondaryHeading={"Latest"}
    >
      {data?.length > 0 ? (
        <DashboardTable
          showHeader={true}
          headerData={headerData}
          tableData={data}
          diplayRows={displayRows}
          handleViewDetails={handleViewDetails}
        />
      ) : (
        <Typography
          variant="h1"
          fontSize={23}
          textAlign={"center"}
          color={appcolors.black}
          mt={20}
        >
          No Upcoming Appointment Found!
        </Typography>
      )}
      <ServiceModal data={selectedRow} open={open} setOpen={setOpen} />
    </Template>
  );
}

export default AppointmentActivity;
